import { createTheme, useTheme as muiUseTheme } from '@mui/material/styles'
import type { Theme } from '@mui/material/styles'

export const globalTheme = (): Theme => {
  return createTheme({
    spacing: 4,
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
      },
    },
  })
}


export const useTheme = (): Theme => {
  return muiUseTheme()
}